import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ThemeType } from '../types';

export type PrecisionAssistType = 'off' | 'pointer' | 'pointer_zoom';

interface ThemeState {
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
  precisionAssist: PrecisionAssistType;
  setPrecisionAssist: (val: PrecisionAssistType) => void;
}

export const useTheme = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'default-height-first',
      setTheme: (theme) => set({ theme }),
      precisionAssist: 'off',
      setPrecisionAssist: (precisionAssist) => set({ precisionAssist }),
    }),
    {
      name: 'theme-storage',
    }
  )
);
